import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy, Inject, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Url } from '@ark-libs/ngx-utils';
import { CoreConfigService } from '../../services/config/core-config.service';

@Component({
    selector: 'zx-iframe',
    templateUrl: './iframe.component.html',
    styleUrls: ['iframe.component.css']
})
export class IFrameComponent implements AfterViewInit {
    iFrameSrc: SafeResourceUrl;
    iFrameHeight:string = 'auto';

    message:string;

    // @ViewChild("iframe") iFrameRef: ElementRef;

    constructor(
        private elementRef: ElementRef,
        private sanitizer: DomSanitizer,
        private activatedRoute: ActivatedRoute,
        private configService: CoreConfigService,
        private router: Router) {

        const src = this.activatedRoute.snapshot.queryParams['src'];
        if(src) this.setIFrameSrc(src);
        else this.activatedRoute.data.subscribe(data => { this.setIFrameSrc(data['iFrameSrc'])});
    }

    ngAfterViewInit(){
        this.initIFrame();
    }

    private setIFrameSrc(src){
        if(src == null) return;

        const selfHref = Url.parse();
        const iframeSrc = Url.relative(src, selfHref);
        // console.log(src, selfHref, iframeSrc);
        if(this.configService.isDevMode&&selfHref.host==iframeSrc.host&&selfHref.port==iframeSrc.port&&selfHref.pathname!=iframeSrc.pathname){
            this.message = "本地开发环境下禁用此功能！("+ iframeSrc.href +")";
            return;
        }else this.iFrameSrc = this.sanitizer.bypassSecurityTrustResourceUrl(iframeSrc.href);
    }

    @HostListener("window:resize", ['$event'])
    initIFrame(event?){
        this.iFrameHeight = "auto";
        setTimeout(()=>{
            try{this.iFrameHeight = (this.elementRef.nativeElement.parentElement.clientHeight) + 'px';}catch{}
        }, 300);
    }
}
